import React, { useEffect, useState } from "react";

import { CachePersistor } from "apollo3-cache-persist";

interface Props {
  loading: React.ReactNode;
  persistor: CachePersistor<any>;
  children: React.ReactNode;
}

const ApolloPersistGate: React.FC<Props> = ({
  persistor,
  loading,
  children,
}) => {
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    persistor.restore().then(() => setBootstrapped(true));
  }, []);

  return <>{bootstrapped ? children : loading}</>;
};

export default ApolloPersistGate;
